export default "__VITE_ASSET__B9288Qoa__"